import React, {FunctionComponent} from 'react';
import styles from './BarChartBar.module.css';
import BarItem from "../bar-item/BarItem";

const BarChartBar: FunctionComponent<{ title: string, values: any[], oldValues: any }> = (
  {
    title,
    values,
    oldValues,
  }) => {

  return (
    <>
      <div
        className={styles.bar}
      >
        <h3 className={styles.legend}>{title}</h3>
        <div
          className={styles.barSectionContainer}
        >
          {values.map((_: any, i: number) => <BarItem values={values} index={i} key={Object.keys(values[i])[0]} oldVal={
              Object.values(
                  Object.values(
                      Object.values(oldValues[1][i])
                  )
          )[0] as number} />)}
        </div>
      </div>
    </>
  );
}

export default BarChartBar;
